<template>
    <leaflet-map 
        :records="records"
        :center="center"
        :zoom="zoomLevel"
        :tile-url="tileUrl"
        :tile-attribution="tileAttribution">
    </leaflet-map>
</template>

<script>
    export default {
        props: {
            locations: { type: Array, required: false, default: function () { return [] } },
            center: { type: Array, required: false, default: undefined },
            zoomLevel: { type: Number, required: false, default: 10 },
            tileUrl: { type: String, required: false, default: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}' },
            tileAttribution: { type: String, required: false, default: 'Map tiles powered by <a href="https://www.esri.com/">Esri</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by/2.0">CC-BY-SA</a>' }
        },

        data() {
            return {
                records: this.locations
            }
        },

        created() {
            EventDispatcher.listen('locationRecordsUpdated', (records) => {
                this.records = records;
            });
        }
    }
</script>